import { createContext, useContext } from "react";

import type {
  IMultiAnalysisActiveMeasureWindow,
  IMultiAnalysisToolbarState,
  IStructureTreePoint,
  MULTI_ANALYSIS_MEASURE_TYPE,
} from "../pages/dashboard/tabs/multi-analysis/types";

export interface IAnalysisToolsContextValue {
  isActive: boolean;
  selectedPointIds: ReadonlySet<number>;
  togglePoint: (point: IStructureTreePoint, checked: boolean) => void;
  setTrainPointsSelected: (points: readonly IStructureTreePoint[], checked: boolean) => void;
  beginTrainPointsSelection: (trainId: number) => (points: readonly IStructureTreePoint[]) => void;
  pointsByTrainId: Readonly<Record<number, IStructureTreePoint[]>>;
  loadingTrainIds: ReadonlySet<number>;
  loadTrainPoints: (trainId: number) => Promise<IStructureTreePoint[]>;
  activeMeasureType: MULTI_ANALYSIS_MEASURE_TYPE | null;
  activeMeasureWindow: IMultiAnalysisActiveMeasureWindow | null;
  toolbarState: IMultiAnalysisToolbarState;
  setToolbarState: (patch: Partial<IMultiAnalysisToolbarState>) => void;
  getCellDisplayCascade3D: (templateId: number, cellId: string) => boolean;
  setCellDisplayCascade3D: (templateId: number, cellId: string, display3D: boolean) => void;
}

const AnalysisToolsContext = createContext<IAnalysisToolsContextValue | null>(null);

export const AnalysisToolsProvider = AnalysisToolsContext.Provider;

export const useAnalysisTools = (): IAnalysisToolsContextValue => {
  const context = useContext(AnalysisToolsContext);

  if (!context) {
    throw new Error("useAnalysisTools must be used within AnalysisToolsProvider");
  }

  return context;
};

export const useOptionalAnalysisTools = (): IAnalysisToolsContextValue | null => useContext(AnalysisToolsContext);
